import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import _ from 'lodash';
import SchemeDocumentRow from './SchemeDocumentRow';
import { PsTable } from '../../shared/components/table/PsTable';

export default class SchemeDocumentsTable extends React.Component {

    renderHead() {
        return (
            <tr>
                <th>{I18nUtils.tr('TR_NOMBRE_ESQUEMA_DOCUMENTOS')}</th>
                <th>{I18nUtils.tr('TR_INCLUYE')}</th>
                <th>{I18nUtils.tr('TR_ACCESO_ESQUEMA')}</th>
            </tr>
        );
    }

    render() {
        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }
        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;

        }

        return (
            <PsTable headings={this.renderHead()}>
                {
                    _.map(this.props.data, object =>
                        <SchemeDocumentRow key={object.id} schemeDocument={object} />,
                    )
                }
            </PsTable>
        );
    }

}

SchemeDocumentsTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,
};
SchemeDocumentsTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/SchemeDocumentsTable.jsx